import { cn } from "@getgreenline/blaze-ui";
import { getBrandInitials } from "@/utils/brands";

type CampaignContextPillProps = {
  brandName?: string | null;
  details?: Array<string | null | undefined>;
  brandFallback?: string;
  className?: string;
};

export function CampaignContextPill({
  brandName,
  details = [],
  brandFallback = "Brand",
  className,
}: CampaignContextPillProps) {
  const visibleDetails = details.filter((detail): detail is string =>
    Boolean(detail),
  );

  return (
    <div className={cn("tw:mt-6", className)}>
      <div className="tw:inline-flex tw:items-center tw:gap-2 tw:rounded-full tw:border tw:border-sky-200 tw:bg-sky-100 tw:px-3 tw:py-1.5 tw:text-sky-700">
        <span className="tw:text-[11px] tw:font-semibold">
          {getBrandInitials(brandName)}
        </span>
        <span className="tw:text-sm tw:font-medium">
          {brandName ?? brandFallback}
        </span>
        {visibleDetails.map((detail, index) => (
          <span key={`${detail}-${index}`} className="tw:contents">
            <span className="tw:text-sky-500">·</span>
            <span className="tw:text-sm tw:font-medium">{detail}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
